import React from 'react';
import pluralize from 'pluralize';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import cn from '@/utils/cn';
import { IImage } from '../../interfaces';
import { useImageModels } from '../MergeHistoryModal.utils';

interface TargetImageCardProps {
  image: IImage;
}

export const TargetImageCard = ({ image }: TargetImageCardProps) => {
  const { data: imageModels } = useImageModels({ image });

  return (
    <div
      className={cn(
        'tw-flex tw-items-center tw-gap-3 tw-py-2 tw-px-3',
        'tw-border tw-border-solid tw-rounded tw-border-med-grey tw-bg-light-grey',
      )}
    >
      <div
        className={cn(
          'tw-box-border tw-w-5 tw-h-5 tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg',
          'tw-text-white tw-bg-tci-purple tw-p-1',
        )}
      >
        <Icon icon="Crown" size={10} />
      </div>
      <img alt={image.image_en_file_name} className="tw-max-w-12" src={image.url} />
      <div className="tw-flex tw-flex-col tw-justify-between tw-gap-1.5">
        <Text className="!tw-leading-none" size="sm" variant="label" weight="bold">
          {image.image_en_file_name}
        </Text>
        <div className="tw-flex tw-items-center tw-gap-1">
          <Text className="!tw-leading-none !tw-text-dark-grey" size="xs" weight="light">
            {`ID: ${image.id}`}
          </Text>
          <Text asChild size="xs">
            <div
              className={cn(
                'tw-text-very-dark-grey tw-bg-light-grey tw-border tw-border-solid',
                'tw-border-med-grey tw-rounded tw-h-4 tw-px-1 tw-flex tw-items-center tw-justify-center',
              )}
            >
              {imageModels.length} {pluralize('use', imageModels.length)}
            </div>
          </Text>
        </div>
      </div>
    </div>
  );
};
